import PageHeader from "@/components/PageHeader";
import ProductGrid from "@/components/ProductGrid";
import MerchGrid from "@/components/MerchGrid";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function Shop() {
  return (
    <div data-testid="shop-page">
      <PageHeader eyebrow="Shop" title="Join a class"
        image="https://customer-assets-agu9un31.emergentagent.net/job_improv-prompt-engine/artifacts/25p79cjl_LA%205.webp"
        subtitle="Live and online classes, workshops, and sessions — fully inclusive, ages 16+, ALL abilities welcome. Consent and participant setup happen at checkout." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4 bg-[#550001] text-white rounded-2xl p-6" data-testid="shop-register-cta">
          <div>
            <h2 className="font-display text-2xl">Registering for an in-person class?</h2>
            <p className="text-sm text-[#ffdedf] mt-1">Use our full registration form to capture participant, guardian, and consent details.</p>
          </div>
          <Button asChild className="bg-white text-[#550001] hover:bg-[#ffdedf] font-bold shrink-0" data-testid="shop-register-btn">
            <Link to="/registration">Register for a class</Link>
          </Button>
        </div>
        <ProductGrid />
        <div className="mt-20 pt-12 border-t border-[#dfd8da]">
          <MerchGrid />
        </div>
      </div>
    </div>
  );
}
